import { defineMessages } from 'react-intl';

export const PoleEmploiTranslations = defineMessages({
  tooltip: {
    id: 'PoleEmploiButton.tooltip',
    defaultMessage:
      "Connectez-vous à MyJobGlasses en utilisant des identifiants France Travail et bénéficiez d'un accès gratuit à ce service.",
  },
});
